import React, { useRef } from "react"
import styled from "styled-components"
import {
  Headline,
  StyledGradientTitle,
  animationProperties,
} from "../../../utils"
import { ArticleCardComponent } from "../../atoms"
import Slider from "react-slick"
import { AosWrapper } from "../../molecules/AosWrapper"
import { MediumList } from "./data"

const Wrapper = styled.div`
  background: ${(props) => props.theme.footerSectionColor};
  padding: 80px 0;
  overflow: hidden;

  /* Horizontal Line Indicators */
  .slick-dots {
    position: relative;
    bottom: 0;
    margin-top: 24px;
    display: flex !important;
    justify-content: center;
    list-style: none;
    padding: 0;

    @media (max-width: 641px) {
      margin-top: 12px;
    }
  }

  .slick-dots li {
    margin: 0 8px;
    width: auto;
    height: auto;
  }

  .slick-dots li button {
    width: 32px;
    height: 4px;
    background: ${(props) => props.theme.gray29};
    border-radius: 10px;
    padding: 0;
    transition: all 0.3s ease;
    border: none;

    &:before {
      display: none;
    }
  }

  .slick-dots li.slick-active button {
    background: ${(props) => props.theme.indicatorGradient};
    width: 32px;
  }

  .slick-arrow {
    display: none !important;
    right: 0;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }

  @media (min-width: 601px) (max-width: 1023px) {
    padding: 50px 0px;
  }

  .slick-slide > div {
    padding-right: 20px;
  }
`

const HeadlineText = styled(Headline)`
  margin-bottom: 40px;
  @media (max-width: 1023px) {
    white-space: break-spaces;
    padding: 0 20px;
    margin-bottom: 20px;
  }
  @media (max-width: 600px) {
    white-space: normal;
    margin-bottom: 20px;
    padding: 0px;
  }
`

const MediumSection = () => {
  const sliderRef = useRef<Slider | null>(null)

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    adaptiveHeight: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    cssEase: "linear",
    variableWidth: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
        },
      },
    ],
    customPaging: () => <button />,
  }

  return (
    <Wrapper id={"blogs"}>
      <AosWrapper>
        <HeadlineText>
          {"Sharing our "}
          <StyledGradientTitle>{"expertise and insights "}</StyledGradientTitle>
          {"with the world\n through our "}
          <StyledGradientTitle>{"blog"}</StyledGradientTitle>
          {"!"}
        </HeadlineText>
        <AosWrapper
          animateIn={"animate__fadeInUpBig animate__zoomIn"}
          duration={animationProperties.duration + 0.2}
          delay={animationProperties.delay + 0.2}
        >
          <Slider ref={(slider) => (sliderRef.current = slider)} {...settings}>
            {MediumList.map((item, index) => (
              <a href={item.link} key={index} target="_blank" rel="noreferrer">
                <ArticleCardComponent
                  articlephoto={item.articlephoto}
                  articletitle={item.articletitle}
                  readingtime={item.readingtime}
                  previewtext={item.previewtext}
                  username={item.username}
                  releasedate={item.releasedate}
                />
              </a>
            ))}
          </Slider>
        </AosWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { MediumSection }
